import React from "react";
import WarmTierRepositorySetupText from "data-tiering/WarmTierRepositorySetupText";
import WarmTierSnapshotsText from "data-tiering/WarmTierSnapshotsText";
import { Alert } from "components/bootstrap";
import { Link, Spinner } from "components/common";
import AppConfig from "util/AppConfig";
import DataTieringRoutes from "./Routes";
import useDataTiering from "./hooks/useDataTiering";
const WarmTierReadinessInfo = () => {
  var _a;
  const { readiness } = useDataTiering();
  if (readiness.isLoading) return /* @__PURE__ */ React.createElement(Spinner, { text: "Fetching readiness information..." });
  const introductionText = "Your Opensearch Cluster is not configured to use the Warm Tier.";
  const alertText = () => {
    var _a2, _b, _c;
    if (!((_a2 = readiness.data) == null ? void 0 : _a2.details.supported_by_search_version)) {
      return /* @__PURE__ */ React.createElement("p", null, "Your Open Search version does not support Searchable Snapshots.");
    }
    if (!((_b = readiness.data) == null ? void 0 : _b.details.restored_snapshots_assignable)) {
      return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("p", null, introductionText), /* @__PURE__ */ React.createElement(WarmTierSnapshotsText, null));
    }
    if (((_c = readiness.data) == null ? void 0 : _c.details.supported_repository_types.length) === 0) {
      return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("p", null, introductionText), /* @__PURE__ */ React.createElement(WarmTierRepositorySetupText, null));
    }
    return null;
  };
  if ((_a = readiness.data) == null ? void 0 : _a.ready) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(Alert, { bsStyle: "warning", title: "Cluster not ready for Warm Tier" }, alertText(), !AppConfig.isCloud() && /* @__PURE__ */ React.createElement("p", null, "The ", /* @__PURE__ */ React.createElement(Link, { to: DataTieringRoutes.WARM_TIER_REPOSITORIES }, "Warm Tier Repositories page"), " guides you through the setup and manages your repositories."));
};
export default WarmTierReadinessInfo;
